import { Locale } from './types';

type PluralForms = {
  zero?: string;
  one: string;
  few?: string;
  many?: string;
  other: string;
};

const PLURAL_RULES: Record<Locale, Intl.PluralRules> = {
  en: new Intl.PluralRules('en'),
  ru: new Intl.PluralRules('ru'),
};

export const choosePluralForm = (
  locale: Locale,
  count: number,
  forms: PluralForms,
): string => {
  if (count === 0 && forms.zero) {
    return forms.zero;
  }

  const category = PLURAL_RULES[locale].select(count);
  if (category === 'one') {
    return forms.one;
  }
  if (category === 'few') {
    return forms.few ?? forms.other;
  }
  if (category === 'many') {
    return forms.many ?? forms.other;
  }
  return forms.other;
};

export const formatCount = (
  locale: Locale,
  count: number,
  forms: PluralForms,
): string => {
  return `${count} ${choosePluralForm(locale, count, forms)}`;
};
